import { CSSProperties, type FunctionComponent, } from "react"

import "./Loader.scss";


export declare type LoaderType = "ellipsis";

export declare type LoaderProps = {
	style?: CSSProperties;
	type?: LoaderType;
	scheme?: "light" | "dark";
	color?: string;
	backgroundColor?: string;
};


export const Loader: FunctionComponent<LoaderProps> = ({
	type = "ellipsis",
	style = { },
	scheme,
	color,
	backgroundColor,
}) => {

	const classes = () => [ `loader`, type, scheme, ].filter(v => v).join(" ");
	style = Object.assign(style, color ? { color, } : {}, backgroundColor ? { backgroundColor, } : {});

	return (
		<div className={classes()} style={style}>
			<div className="brace">
				{ shapes[type] }
			</div>
		</div>
	);

}

const shapes: Record<LoaderType, JSX.Element> = {
	ellipsis: <><div></div><div></div><div></div><div></div></>,
}
